import { atom } from 'jotai';

import { productsState } from './products.state';

export const selectedRowsCountState = atom((get) => {
  const products = get(productsState);
  return products.filter((p) => p.activeVersion.isSelected).length;
});
